<div class="content-pane">
  <h2>Edit Project Details and Related Resources</h2>

  <form [formGroup]="form" (ngSubmit)="submit($event)">
    <formly-form [model]="model" [fields]="formFields" [options]="options" [form]="form" class="standard"></formly-form>

    <div class="form-actions mt-4">
      <button matButton="filled" color="primary" type="submit" [disabled]="submitting || form.pending">
        <mat-icon class="material-symbols-outlined">check</mat-icon>
        Save
      </button>

      <a matButton="filled" class="cancelbtn" [routerLink]="['/private-data-enclave/project/view', project()?.id]">
        <mat-icon class="material-symbols-outlined">remove_circle</mat-icon>
        Cancel
      </a>
    </div>
  </form>
</div>
